module.exports = __webpack_public_path__ + "img/2025-03-12b_1.96b967f4.jpg";